import { createWidget } from "@opendash/plugin-monitoring";
import React from "react";
import { ConfigInterface } from "./types";

export default createWidget<ConfigInterface>({
  type: "opendash-widget-hc-kpi",
  meta: {},
  displayComponent: React.lazy(() => import("./component")),
  settingsComponent: React.lazy(() => import("./settings")),

  dataItems: {
    select: "dimension",
    min: 1,
    max: 1,
    types: ["Boolean", "Number", "String"],
  },
  hideDataFilter: true,
  presets: [
    {
      label: "highcharts:explorer.kpi.title",
      description: "highcharts:explorer.kpi.description",
      tags: ["kpi"],
      imageLink: async () => (await import("./res_425")).default,
      widget: {
        config: {
          icon: "fa:info",
        },
      },
    },
  ],
});
